<template>
  <div>
    <BaseSectionHeader class="mb-4">
      {{ $t('My summary') }}
    </BaseSectionHeader>
    <BaseParagraph class="mb-8 summary">
      {{ $t('Invested amount') }} :
      <BaseCurrencySpan :value="investment.data.attributes.totalAmount" />
      <br>
      {{ $t('Shares held') }} :
      {{ investment.data.attributes.totalShares | currency('') }}
      <br>
      {{ $t('Average buying share price') }} :
      {{ investment.data.attributes.buyingSharePrice | currency({ fractionCount: 2 }) }}
      <br>
      {{ $t('Last share price') }} :
      {{ operation.attributes.shareValue | currency({ fractionCount: 2 }) }}
      <template v-if="participation.attributes.operationDetails">
        <br><br>
        {{ participation.attributes.operationDetails }}
      </template>
    </BaseParagraph>
    <div
      v-for="operation in operations"
      :key="operation.id"
      class="border-t border-shadow-color mb-8 event"
    >
      <BaseSectionHeader class="pt-4">
        {{ $t('Operation of') }} {{
          getParticipationOperation(operation).attributes.date | moment('MM/YYYY')
        }}
      </BaseSectionHeader>
      <BaseLabelledInfo :label="$t('Date')">
        {{ getParticipationOperation(operation).attributes.date | moment('DD/MM/YYYY') }}
      </BaseLabelledInfo>
      <BaseLabelledInfo :label="$t('My investment')">
        <BaseCurrencySpan :value="getEvent(operation).attributes.amount" />
      </BaseLabelledInfo>
      <BaseLabelledInfo :label="$t('Named acquired shares', { name: spv.attributes.name })">
        {{ getEvent(operation).attributes.acquiredShares | currency('') }}
      </BaseLabelledInfo>
      <BaseLabelledInfo :label="`${$t('Share price')} ${spv.attributes.name}`">
        {{ operation.attributes.shareValue | currency({ fractionCount: 2 }) }}
      </BaseLabelledInfo>
      <BaseLabelledInfo :label="`${$t('Pre-money value')} ${participation.attributes.name}`">
        <BaseCurrencySpan :value="getParticipationOperation(operation).attributes.preMoneyValue" />
      </BaseLabelledInfo>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash';
import { mapGetters } from 'vuex';
import BaseSectionHeader from '../../components/BaseSectionHeader.vue';
import BaseLabelledInfo from '../../components/BaseLabelledInfo.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';
import BaseCurrencySpan from '../../components/BaseCurrencySpan.vue';
import loadInvestment from '../../mixins/loadInvestment';

export default {
  name: 'InvestmentDetailsContent',
  components: {
    BaseSectionHeader,
    BaseLabelledInfo,
    BaseParagraph,
    BaseCurrencySpan,
  },
  mixins: [loadInvestment],
  computed: mapGetters('investment', ['getOperation']),
  methods: {
    sharePercentage(event) {
      return (event.attributes.acquiredShares / event.attributes.totalShares) * 100;
    },
    getParticipationOperation(operation) {
      const { data } = operation.relationships.participationOperation;
      return find(this.participationOperations, data);
    },
    getEvent(operation) {
      const event = find(this.siblings, sibling =>
        sibling.relationships.spvFinancialOperation.data.id === operation.id);
      if (event) {
        return event;
      }
      return { attributes: { amount: 0 } };
    },
    getSpvOperation(event) {
      const { id } = event.relationships.spvFinancialOperation.data;
      return this.getOperation(id);
    },
  },
};
</script>
